import { NgModule } from '@angular/core'
import { PassEventToDirective } from './pass-event-to.directive'

@NgModule({
  declarations: [PassEventToDirective],
  exports: [PassEventToDirective]
})
export class PassEventToDirectiveModule {}
